import React from "react"
import {useWatch} from "react-hook-form"
import {Alert, AlertDescription, AlertIcon, AlertTitle, Box} from "@chakra-ui/react"

import {HRadio} from "@components/headlessui/HRadio"
import UserSelect, {PickedUser} from "@modules/user/components/UserSelect"
import GroupSelect, {PickedGroup} from "@modules/user/components/GroupSelect"

import {AccessOptionKeys, accessOptions} from "../../constants"

type GameAccessProps = {
    parentField?: string,
    field: string,
    rules?: any,
    register: any,
    defaultValue?: string,
    users?: PickedUser[],
    groups?: PickedGroup[],
    control?: any,
    onSelect: (field: string, value: string) => void,
    onSelectedChange: (any) => void
}

export function GameAccess(props: GameAccessProps) {
    const {
        parentField,
        field,
        rules,
        register,
        defaultValue,
        users,
        groups,
        control,
        onSelect,
        onSelectedChange
    } = props

    const watch = useWatch({name: parentField ? `${parentField}.${props.field}` : props.field, control})

    function renderComp(accessKey: AccessOptionKeys) {

        switch (accessKey) {
            case "public":
                return <Alert status="info">
                    <AlertIcon/>
                    <Box>
                        <AlertTitle>Public Game</AlertTitle>
                        <AlertDescription>
                            Your game will be public and visible to everyone
                        </AlertDescription>
                    </Box>
                </Alert>
            case "private":
                return <Alert status="info">
                    <AlertIcon/>
                    <Box>
                        <AlertTitle>Private Game</AlertTitle>
                        <AlertDescription>
                            Your game will be private and only visible to you
                        </AlertDescription>
                    </Box>
                </Alert>
            case "privateToUsers":
                return <UserSelect
                    users={users}
                    onUsersChange={onSelectedChange}/>
            case "privateToGroups":
                return <GroupSelect
                    groups={groups}
                    onGroupsChange={onSelectedChange}/>
        }
    }

    return <>
        <div className="col-span-full sm:col-span-3">
            <HRadio
                parentField={parentField}
                register={register}
                field={field}
                rules={rules}
                value={watch}
                layout="vertical"
                setValue={onSelect}
                options={Object.values(accessOptions)}
            />
        </div>
        <div className="col-span-full sm:col-span-3">
            {renderComp(watch)}
        </div>
    </>
}